module.exports = __webpack_public_path__ + "img/source_book-con02.84871d8c.png";